import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

type KnownConnectiesArgs = {
  currentPhase: string;
  connectionId: string;
  selectedConnectionData: any;
  setSelectedConnectionData: (updater: any) => void;
  setCompletionNotice: (msg: string | null) => void;
  setToastMessage: (msg: string) => void;
  setNextStepChoiceOpen: (open: boolean) => void;
};

export async function handleKnownConnectiesCompletion({
  currentPhase,
  connectionId,
  selectedConnectionData,
  setSelectedConnectionData,
  setCompletionNotice,
  setToastMessage,
  setNextStepChoiceOpen
}: KnownConnectiesArgs): Promise<boolean> {
  const verificationOnly = Boolean(selectedConnectionData?.knownContactVerificationOnly);

  if (currentPhase !== 'call' || !verificationOnly) {
    return false;
  }

  await updateDoc(doc(db, 'connections', connectionId), {
    status: 'accepted',
    phaseStatus: 'done',
    knownContactVerificationCompleted: true,
    verificationCompletedAt: new Date()
  });

  setSelectedConnectionData((prev: any) =>
    prev
      ? {
          ...prev,
          status: 'accepted',
          phaseStatus: 'done',
          knownContactVerificationCompleted: true
        }
      : prev
  );

  setCompletionNotice('Connectie afgerond.');
  setToastMessage('✅ Connectie afgerond');
  setNextStepChoiceOpen(false);

  return true;
}
